import axios from 'axios';

// Environment variables are now working

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';
const ADMIN_TOKEN = 'f47ac10b-58cc-4372-a567-0e02b2c3d479';

// Get token from URL params
const getToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('token');
};

export const AdminService = {
  getSessions: async (page: number = 1, limit: number = 50) => {
    if (!API_BASE_URL) {
      throw new Error('API_BASE_URL is not configured');
    }
    const token = getToken();

    const response = await axios.get(`${API_BASE_URL}/api/admin/sessions`, {
      params: { page, limit },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // Extract data from the nested response structure
    return response.data.data;
  },

  getProducts: async (sessionId: string) => {
    if (!API_BASE_URL) {
      throw new Error('API_BASE_URL is not configured');
    }
    const token = getToken();
    const response = await axios.get(`${API_BASE_URL}/api/admin/sessions/${sessionId}/products`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  },

  getSides: async (productId: string) => {
    if (!API_BASE_URL) {
      throw new Error('API_BASE_URL is not configured');
    }
    const token = getToken();
    const response = await axios.get(`${API_BASE_URL}/api/admin/products/${productId}/sides`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  },

  getDailySessionStats: async (days: number = 30, conneoId?: string) => {
    if (!API_BASE_URL) {
      throw new Error('API_BASE_URL is not configured');
    }

    const params = new URLSearchParams();
    params.append('days', days.toString());
    if (conneoId) {
      params.append('conneoId', conneoId);
    }

    const response = await axios.get(
      `${API_BASE_URL}/api/sessions/stats/daily?${params.toString()}`,
      {
        headers: {
          token: '8e204148-e3ad-42cb-9436-f6edbe2a63c3',
        },
      },
    );
    return response.data.data.dailyStats;
  },

  getSessionFunnelStats: async (month: string) => {
    if (!API_BASE_URL) {
      throw new Error('API_BASE_URL is not configured');
    }

    const response = await axios.get(`${API_BASE_URL}/api/sessions/stats/funnel?month=${month}`, {
      headers: {
        token: '8e204148-e3ad-42cb-9436-f6edbe2a63c3',
      },
    });
    return response.data.data;
  },
};
